/**
 * AI Image Tagging
 * Fügt automatisch ein "AI"-Badge (unten rechts) zu allen Bildern hinzu,
 * deren Dateiname vor der Endung auf "-ai" endet, z. B.:
 *   produktname-ai.jpg
 *   produktname-ai_600x600crop_center.jpg
 *   produktname-ai.png?v=123456
 *
 * PERFORMANCE-HINWEISE:
 * - Der initiale Scan läuft einmalig beim DOM-Ready über das gesamte Dokument.
 * - Danach werden NUR neu hinzugefügte DOM-Knoten geprüft (nicht erneut das
 *   gesamte Dokument), um unnötige querySelectorAll-Aufrufe zu vermeiden.
 * - Mehrere schnell aufeinanderfolgende DOM-Änderungen (z. B. durch Apps,
 *   Slider, Variantenwechsel) werden gebündelt und erst in einem
 *   Leerlaufmoment des Browsers (requestIdleCallback) verarbeitet, um den
 *   Main Thread nicht zu blockieren (TBT/INP-Schonung).
 * - getComputedStyle() wird ausschließlich für tatsächlich erkannte
 *   AI-Bilder aufgerufen, nicht für jedes Bild im Shop.
 *
 * Einbindung in Shopify:
 * 1. Diese Datei als "ai-image-tag.js" in Assets hochladen.
 * 2. In theme.liquid vor </body> einfügen:
 *    {{ 'ai-image-tag.js' | asset_url | script_tag }}
 * 3. ai-image-tag.css ebenfalls in Assets hochladen und einbinden
 *    (in theme.liquid <head> oder über {{ 'ai-image-tag.css' | asset_url | stylesheet_tag }}).
 */
(function () {
  var AI_PATTERN = /-ai(_\d+x\d*|_\d*x\d+)?[a-z_]*\.(jpg|jpeg|png|webp|gif|avif)(\?|$)/i;

  // Bereiche, die von der AI-Tag-Logik ausgeschlossen werden sollen:
  // Navigations-/Menü-Bilder benötigen keine AI-Kennzeichnung (betrifft nur
  // Produkt-/Content-Bilder) UND enthalten oft JS-Logik (z. B. jQuery .next()),
  // die auf die exakte, unveränderte Geschwister-Struktur angewiesen ist.
  var EXCLUDED_SELECTORS = [
    '.lb-mobile-navigation',
    'header',
    'nav',
    '.menu-drawer',
    '.header-drawer',
    // AOV.ai Cart Drawer – laut App-Support bestätigter Container
    '#aov-cart-drawer'
  ];

  // requestIdleCallback-Fallback für Browser ohne Unterstützung (z. B. Safari < 2023)
  var scheduleIdle = window.requestIdleCallback
    ? function (cb) { window.requestIdleCallback(cb, { timeout: 500 }); }
    : function (cb) { setTimeout(cb, 100); };

  // Sucht beim Bild bzw. dessen Vorfahren nach einer bereits vorhandenen
  // border-bottom-right-radius, damit sich das Tag optisch an abgerundete
  // Bildecken anpasst (z. B. bei Hero-Bannern mit "abgerundet"-Einstellung).
  function findMatchingRadius(startEl) {
    var node = startEl;
    for (var i = 0; i < 8 && node && node !== document.body; i++) {
      var cs = window.getComputedStyle(node);
      var radius = cs.borderBottomRightRadius;
      if (radius && parseFloat(radius) > 0) {
        return radius;
      }
      node = node.parentElement;
    }
    return '0px';
  }

  function isExcluded(img) {
    for (var i = 0; i < EXCLUDED_SELECTORS.length; i++) {
      if (img.closest(EXCLUDED_SELECTORS[i])) return true;
    }
    return false;
  }

  function processImage(img) {
    if (img.hasAttribute('data-ai-checked')) return;
    img.setAttribute('data-ai-checked', 'true');

    if (isExcluded(img)) return;

    var src = img.currentSrc || img.getAttribute('src') || '';
    if (!AI_PATTERN.test(src)) return;

    // Den Bild-Container finden (z. B. die .media-Box bei Dawn-basierten Themes,
    // die mehrere Bilder als direkte Geschwister für Hover-Effekte enthält).
    var mediaBox = img.closest('.media') || img.parentElement;
    if (!mediaBox) return;

    // Falls diese Box schon getaggt wurde, nichts weiter tun
    if (mediaBox.getAttribute('data-ai-tagged') === 'true') return;
    mediaBox.setAttribute('data-ai-tagged', 'true');

    var outerParent = mediaBox.parentNode;
    if (!outerParent) return;

    // Prüfen, ob die Box aus dem Dokumentfluss genommen ist (z. B. Hero-Banner
    // mit position: absolute, um Text-Elemente nicht zu verschieben).
    var mediaComputedPosition = window.getComputedStyle(mediaBox).position;
    var isOutOfFlow = mediaComputedPosition === 'absolute' || mediaComputedPosition === 'fixed';

    // Neuen Wrapper NUR außen um die Box legen.
    // Die Box selbst (inkl. aller Kind-Bilder, Reihenfolge, Klassen) wird
    // unverändert hineinverschoben – dadurch bleiben sämtliche
    // Sibling-/Hover-CSS-Regeln des Themes intakt.
    var outerWrapper = document.createElement('span');
    outerWrapper.className = isOutOfFlow ? 'ai-tag-outer ai-tag-outer--absolute' : 'ai-tag-outer';
    outerParent.insertBefore(outerWrapper, mediaBox);
    outerWrapper.appendChild(mediaBox);

    // Badge als Geschwister von .media anhängen (nicht als Kind davon)
    var badge = document.createElement('span');
    badge.className = 'ai-tag-badge';
    badge.textContent = 'AI';
    badge.style.borderRadius = '0 0 ' + findMatchingRadius(mediaBox) + ' 0';
    outerWrapper.appendChild(badge);
  }

  // Scannt EIN gegebenes Root-Element (z. B. document beim initialen Scan,
  // oder einen einzelnen neu hinzugefügten Knoten bei späteren Updates)
  function scanRoot(root) {
    if (!root) return;
    // Erlaubt: Element (1), Document (9), DocumentFragment (11).
    // Vorher wurde nur nodeType 1 akzeptiert – dadurch lief der initiale
    // Scan über "document" (nodeType 9) nie, und es wurde kein Bild geprüft.
    if (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11) return;

    if (root.nodeType === 1 && root.tagName === 'IMG') {
      processImage(root);
      return;
    }

    if (typeof root.querySelectorAll !== 'function') return;
    var images = root.querySelectorAll('img:not([data-ai-checked])');
    for (var i = 0; i < images.length; i++) {
      processImage(images[i]);
    }
  }

  // Initialer Scan über das gesamte Dokument (einmalig)
  document.addEventListener('DOMContentLoaded', function () {
    scanRoot(document);
  });

  // Sammelt neu hinzugefügte Knoten aus mehreren Mutations-Bursts und
  // verarbeitet sie gebündelt in einem Leerlaufmoment des Browsers,
  // statt bei jeder einzelnen DOM-Änderung sofort zu reagieren.
  var pendingNodes = [];
  var scanScheduled = false;

  function flushPendingNodes() {
    scanScheduled = false;
    var nodes = pendingNodes;
    pendingNodes = [];
    for (var i = 0; i < nodes.length; i++) {
      scanRoot(nodes[i]);
    }
  }

  var observer = new MutationObserver(function (mutations) {
    for (var m = 0; m < mutations.length; m++) {
      var added = mutations[m].addedNodes;
      for (var n = 0; n < added.length; n++) {
        if (added[n].nodeType === 1) {
          pendingNodes.push(added[n]);
        }
      }
    }

    if (pendingNodes.length && !scanScheduled) {
      scanScheduled = true;
      scheduleIdle(flushPendingNodes);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();